import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const subscriptionTierImporterSelectors = importerSelectors(
  'subscriptionTier.importer',
);

export default subscriptionTierImporterSelectors;
